
import { Component, Model, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import { ContainsLessThanPercentOfContent } from "@/models/NutritionLabels/ContainsLessThanPercentOfContent";
import Translations from "@/models/Localization/Translations";
import { LocalizationState } from "@/store/modules/LocalizationModule";

@Component({
  computed: {
    ...mapState({
      localizationState: (state: any) => state.LocalizationModule,
    }),
  },
})
export default class vUSContainsPercentOfForm extends Vue {
  @Model() model!: ContainsLessThanPercentOfContent;

  private localizationState!: LocalizationState;

  // Values as specified by CR82
  acceptableThresholds = [0.5, 1.0, 1.5, 2.0];

  get translations(): Translations {
    return this.localizationState.translations;
  }
}
